// Novas Vendas (Gestão Orçamentária): carteira de novos contratos/aditivos e sua
// distribuição mensal (visão executiva, não escopada por departamento — mesmo
// público de Faturamento Bruto).
// Espelha backend/config.py ROLES_NOVAS_VENDAS_ORCAMENTARIA — mantenha em sincronia.
export const ROLES_NOVAS_VENDAS_ORCAMENTARIA = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
